import React, { Component } from 'react';
import { Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Spinner } from 'react-activity';
import { store } from 'react-notifications-component';
import CSVButton from '../../Helpers/CsvButton';
import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';
import Backend from '../../Backend';
import Connection from '../../Calls';

import SearchImage from '../../Images/search.svg';

import './index.css'

var date = new Date();
// var HeightScreen = window.screen.height;

function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

class EcommerceIndex extends Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef();
    this.state = {
      page:1,
      page_size:30,
      pages_amount:1,
      amount_orders:0,
      date_from:'',
      date_to:'',
      search:'',
      ecommerce:'',
      list_orders:[],
      coins_settings:[{}],
      list_orders_csv:[],
      headers:[],
    }
  }

  addNotification(status,msg,type){
    store.addNotification({
      title: status,
      message: msg,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 2500,
        onScreen: true
      }
    });
  }
  componentWillMount() {
    this.loadData()
  }

  loadData(){
    const self = this
    this.getEcommSettings()
    this.getOrders()
  }

  getEcommSettings(){
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.general_get('get_wallets_settings',response.payload.r01,response=>{
        if(response.status.code == "18004") this.props.data.history.push('/ecommerce/create')
        else this.setState({ecommerce:true, ...response.payload})
      })
      Backend.general_get('get_general_settings',response.payload.r01,response=>{
        if(response.status.code == '0') this.setState({ ...response.payload.general_settings })
      });

      Backend.get_ecomm_image(response.payload.r01, response =>{
        if(response.status.code == '0')
          this.setState({img_base64:'data:image/png;base64,'+response.payload.img_b64})
      })
    })
  }

  async getOrders(){
    let { page_size } = this.state
    let orders_promise = new Promise((resolve)=> this.ordersAPI(resolve))
    let orders_data = await orders_promise
    if(orders_data.status.code == '0'){
      let { list_orders, amount_orders } = orders_data.payload
      let pages_amount = Math.ceil(amount_orders / page_size);
      this.setState({list_orders, pages_amount})
    }
  }

  ordersAPI(resolve){
    let body = this.state
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.get_orders_list(localStorage.getItem('email'),localStorage.getItem('token'),response.payload.r01, body, resolve)
    })
  }

  changePage(page) {
    this.setState({page}, ()=>this.getOrders());
  }

  updateImg(){
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", async response => {
      Backend.upload_file(localStorage.getItem('email'), localStorage.getItem('token'),this.state.ecomm_img,'f_ecomm_logo',response.payload.r01, response => {
        if (response.status.code === '0'){
          this.addNotification("Success!", "Successfully uploaded", "success")
        } else {
          this.addNotification("Error!","error upload","danger");
          this.setState({...this.state.ecomm_img})
        }
      })
    })
  }

  _onChangeImage(){
      var file = this.fileInput.files[0];
      var fileType = file?.name?.split(".")[file?.name?.split(".").length-1].toLowerCase()
      var reader = new FileReader();
      reader.readAsDataURL(file);
      if (file.size > 8000000) {
          document.getElementById("img").value = "";
          this.addNotification("Error!","Image exceeds 8MB.","danger");
      }else if (fileType != 'jpeg' && fileType != 'png' && fileType != 'jpg' && fileType != 'pdf'){
          document.getElementById("img").value = "";
          this.addNotification("Error!", "Only .jpeg .png or .pdf files are acceptable","danger");
      }else {
          reader.onloadend = function (e) {
              var image_split = [reader.result][0];
              this.setState({
                ecomm_img:{
                  img: [reader.result],
                  base64: image_split.split(",")[1],
                  base64Type: fileType,
                  imgFile: file,
                  imgName: file.name,
                  correctUpload:false
                },
                img_base64:[reader.result][0]
              })
          }.bind(this);
          this.updateImg()
      }
     
  }

  handleReportCsv(callback) {
    let { ecomm } = this.props.traductions
    let body = {
      date_from : this.state.date_from,
      date_to : this.state.date_to,
      page_size: 0,
      page: 0,
      search: '',
    }

    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.get_orders_list(localStorage.getItem('email'),localStorage.getItem('token'),response.payload.r01, body, response => {
        if (response.status.code === '0'){
          const {list_orders} = response.payload
          const keyMapping = {
            reference: "#" + ecomm.order,
            type: ecomm.source,
            address: ecomm.address,
            amount_usd: ecomm.amountUSD,
            created_date: ecomm.fecha,
            coin: ecomm.crypto,
            status: ecomm.state,
            client_email: ecomm.email,
            internal_payment: ecomm.wb_transfer,
            terminal_name: ecomm.devices,
            id: 'ID',
          };

          const newArray = list_orders.map(obj => {
            const newObj = {};
            Object.entries(keyMapping).forEach(([key, value]) => {
              if (key === 'amount_usd') {
                newObj[ecomm?.amountUSD] = `${obj['amount_usd']} ${obj['currency']}`;
              } else {
                newObj[value] = obj[key];
              }
            });
            return newObj;
          });
          callback(newArray)
        }
      })
    })
  }

  renderList(){
    let { ecomm } = this.props.traductions
    return this.state.list_orders.map((item)=>{
      return(
        <tr>
          <td>{item.reference}</td>
          <td>{item.terminal_name || 'Web'}</td>
          <td>{item.address}</td>
          <td>{formatMoney(item.amount_usd)} {item.currency || 'usd'}</td>
          <td>{item.created_date}</td>
          <td>{item.coin}</td>
          <td className={item.status}>{ecomm[item.status] || item.status}</td>
          <td className='see-more' onClick={()=>this.props.data.history.push('/ecommerce/' + item.id)}>{ecomm.seeMore}</td>
        </tr>
      )
    })
  }
  renderContent(){
      let { coins_settings, currency } = this.state
      let { auto_vex } = coins_settings[Object.keys(coins_settings)[0]]
      let { ecomm } = this.props.traductions
      switch (this.state.ecommerce) {
        case (true):
          return(
            <div className="ecommerce" style={{ paddingLeft: 10, paddingRight: 10 }}>
              <div className='space-between wrap bmargin'>
                <div className='flex'>
                  {/* <div style={{marginBottom:10,borderRadius:100, height:80, width:80, display:'inline-block', overflow:'hidden'}}>
                    {
                      this.state.img_base64
                      ?<Image style={{height:80, width:80}} src={this.state.img_base64}/>
                      :''
                    }
                  </div> */}
                  <div style={{borderRadius:100, height:100, width:100, display:'inline-block', overflow:'hidden', position:'relative'}}>
                  {
                    this.state.img_base64
                    ?<Image style={{height:100, width:100}} src={this.state.img_base64}/>
                    :''
                  }
                  <Form.Control
                      style={{ display:'none' }}
                      ref={fileInput => this.fileInput = fileInput}
                      id="img"
                      type="file"
                      name="user[image]"
                      multiple={false}
                      accept={"image/png, image/jpeg, image/jpg"}
                      size="2000000"
                      onChange={() =>  this._onChangeImage() }
                  />
                  <div className='ecomm-img-button' onClick={()=>this.fileInput.click()}>
                    Change
                  </div>
                </div>
                  <div style={{marginBottom:10,marginLeft:10}}>
                    <p className='ecommerce-title'>{ecomm.myecomm}</p>
                    <p className='ecommerce-subtitle'>{this.state.ecomm}</p>
                  </div>
                </div>
                <div className='ecommerce-top-right-container'>
                  <div className='flex1 ctext'>
                    <p className='ecommerce-title'>{ecomm.vextitle} {currency === "usd" ? "V-USD" : "V-MXN"}</p>
                    <p className='ecommerce-text'>{ecomm.auto[auto_vex]}</p>
                  </div>
                  <div className='ecommerce-top-right-divider'/>
                  <div className='flex1 ctext'>
                    <p className='ecommerce-title'>{ecomm.fiatW}</p>
                    <p className='ecommerce-text'>{ecomm[this.state.fiat_interval]}</p>
                  </div>
                </div>
              </div>

              <div className='space-between wrap bmargin10'>
                <span className='ecommerce-subtitle'>{ecomm.history}</span>
                <div>
                  <Button onClick={()=>this.props.data.history.push('/ecommerce/thatsit')} className='ecommerce-button index bmargin10' style={{marginRight:10}}>{ecomm.b_thats}</Button>
                  <Button onClick={()=>this.props.data.history.push('/ecommerce/devices')} className='ecommerce-button index bmargin10' style={{marginRight:10}}>{ecomm.b_devices}</Button>
                  <Button onClick={()=>this.props.data.history.push('/ecommerce/wallets')} className='ecommerce-button index bmargin10' style={{marginRight:10}}>{ecomm.b_wallets}</Button>
                  <Button onClick={()=>this.props.data.history.push('/ecommerce/config')} className='ecommerce-button index bmargin10'>{ecomm.b_settings}</Button>
                </div>
              </div>
              <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                <CSVButton  label={ecomm.btn_export} variant="link" fileName='ecomm-orders' onClick={(callback)=>{this.handleReportCsv(callback)}}/>
              </div>
              <div className='container-transactions'>
                <div>
                  <Row>
                    <Col md={3} className='virtual_exchange_dropdown'>
                      <Form.Label className="virtual_exchange_information_wallets_text">{ecomm.starting_date}:</Form.Label>
                      <FormControl
                        type="date"
                        className="input-signup"
                        value={this.state.date_from}
                        onChange={(date_from) => { this.setState({ date_from: date_from.target.value }) }}
                        />
                    </Col>
                    <Col md={3} className='virtual_exchange_dropdown'>
                      <Form.Label className="virtual_exchange_information_wallets_text">{ecomm.ending_date}:</Form.Label>
                      <FormControl
                        type="date"
                        className="input-signup"
                        value={this.state.date_to}
                        onChange={(date_to) => { this.setState({ date_to: date_to.target.value }) }}
                        />
                    </Col>

                    <Col md={5} className='virtual_exchange_dropdown'>
                      <Form.Label className="virtual_exchange_information_wallets_text">{ecomm.search}:</Form.Label>
                      <Form.Control style={{ height: 40 }} className="input-signup" type="text" placeholder={ecomm.search} value={this.state.search} onKeyPress={this.handleKeyPress} onChange={(search) => { this.setState({ search: search.target.value }) }} />
                    </Col>

                    <Col md={1}>
                      <div style={{ paddingTop: 24, textAlign:'center'}}>
                        <Button className="signup-button" style={{ height: 40, width:40, padding: 0 }} onClick={() => { this.getOrders(1, 25, "date_new"); }}>
                          <Image src={SearchImage} style={{ width: 20, marginTop:-4 }} />
                        </Button>
                      </div>
                    </Col>
                  </Row>

                  <div style={{ height: "calc(100vh - 530px)" }} className="scroll-table-wallets-generals">
                    <table className="ecommerce-table medium-dms">
                      <thead>
                        <tr>
                          <th># {ecomm.order}</th>
                          <th>{ecomm.source}</th>
                          <th>{ecomm.address}</th>
                          <th>{ecomm.amountUSD}</th>
                          <th>{ecomm.fecha}</th>
                          <th>{ecomm.crypto}</th>
                          <th>{ecomm.state}</th>
                          <th style={{width:100}}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderList()}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 20 }}>
                    <DropdownButton id="dropdown-item-button-step1" title={this.state.numeroFilas}>
                      <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 25 }) }} as="button">25</Dropdown.Item>
                      <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 50 }); }} as="button">50</Dropdown.Item>
                      <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 100 }); }} as="button">100</Dropdown.Item>
                    </DropdownButton>
                    <Pagination>
                      <Pagination.First disabled={this.state.page === 1 || this.state.spinner} onClick={() => {
                        if (this.state.page !== 0) {
                          this.changePage(1);
                        }
                      }} />
                      <Pagination.Prev disabled={this.state.page === 1 || this.state.spinner} onClick={() => {
                        if (this.state.page !== 0) {
                          this.changePage(this.state.page - 1);
                        }
                      }} />
                      {this.state.page > 2 &&
                        <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.page - 2) }}>{this.state.page - 2}</Pagination.Item>
                      }
                      {this.state.page > 1 &&
                        <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.page - 1) }}>{this.state.page - 1}</Pagination.Item>
                      }
                      <Pagination.Item active>{this.state.page}</Pagination.Item>
                      {this.state.page < this.state.pages_amount &&
                        <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.page + 1) }}>{this.state.page + 1}</Pagination.Item>
                      }
                      {this.state.page < this.state.pages_amount - 1 &&
                        <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.page + 2) }}>{this.state.page + 2}</Pagination.Item>
                      }
                      <Pagination.Next disabled={this.state.page >= this.state.pages_amount || this.state.spinner} onClick={() => {
                        if (this.state.page < this.state.pages_amount) {
                          this.changePage(this.state.page + 1)
                        }
                      }} />
                      <Pagination.Last disabled={this.state.page >= this.state.pages_amount || this.state.spinner} onClick={() => {
                        if (this.state.page < this.state.pages_amount) {
                          this.changePage(this.state.pages_amount)
                        }
                      }} />
                    </Pagination>
                  </div>
                </div>

              </div>
            </div>
          )
        default:
          return  <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'calc(100vh - 87px)'}}><Spinner animated color='#053164' size={90}/></div>

      }
  }


  render() {
    return (
      <div>
        <NavbarComponent data={this.props} selected="ecommerce" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10 }}>
          {this.renderContent()}
        </div>
      </div >
    );
  }
} export default EcommerceIndex;
